import React, { useState, useEffect, useMemo } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'gatsby';
import { toJobPostingPurchase } from '../../routes';
import { FaBriefcase } from 'react-icons/fa';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch-dom';
import SearchBox from './searchBox';
import SearchResult from './searchResult';
import classNamesFcn from 'classnames';
import { navigate, useLocation } from '@gatsbyjs/reach-router';

import {
  GATSBY_ALGOLIA_APP_ID,
  GATSBY_ALGOLIA_SEARCH_KEY,
  jobSearchIndices,
} from './searchConstants';

const JobSearchInputBlock = (props) => {
  const { classNames, isMainHeader } = props;
  const location = useLocation();
  const [query, setQuery] = useState('');

  const algoliaClient = useMemo(
    () => algoliasearch(GATSBY_ALGOLIA_APP_ID, GATSBY_ALGOLIA_SEARCH_KEY),
    []
  );

  useEffect(() => {
    if (location?.state?.query) {
      setQuery(location.state.query);
    }
  }, []);

  const searchClient = {
    ...algoliaClient,
    search(requests) {
      if (requests.every(({ params }) => params.query.trim().length < 3)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
          })),
        });
      }

      return algoliaClient.search(requests);
    },
  };

  async function goToLink(link) {
    await navigate('/', { state: { query: query }, replace: true });
    navigate(link);
  }

  return (
    <Card
      className={`${classNames} pt-4 px-lg-5`}
      style={{ width: '1061px', maxWidth: '100%' }}
    >
      <CardBody className="d-flex flex-column">
        {isMainHeader ? (
          <h1 className="mb-3">Find your Next Dental Job Here</h1>
        ) : (
          <h2 className="mb-3">
            {!!props.header ? props.header : 'Find the dental job you love'}
          </h2>
        )}

        <p className="dp-font-lg" style={{ marginBottom: '32px' }}>
          Join the nation's largest job board for dental professionals.
        </p>

        <div className="mb-3">
          <InstantSearch
            searchClient={searchClient}
            indexName={jobSearchIndices[0].name}
            onSearchStateChange={({ query }) => {
              setQuery(query);
            }}
            searchState={{
              query: query,
            }}
          >
            <SearchBox
              className="dp-search-input"
              placeholder="Search jobs by location, position, employer, etc"
              autoFocus={false}
            />
            <SearchResult
              indices={jobSearchIndices}
              goToLink={goToLink}
              className={classNamesFcn('dp-search-results', {
                'd-none': !(query && query.trim().length > 2),
              })}
            />
          </InstantSearch>
        </div>

        <p className="text-center text-lg-start">
          <FaBriefcase className="me-2 fw-bold" /> <b>For employers </b>
          <Link to={toJobPostingPurchase} className="ms-2">
            Post a job
          </Link>
        </p>
      </CardBody>
    </Card>
  );
};

export default JobSearchInputBlock;
